import React, { useState, useEffect } from 'react';
import './App.css';
import Navigation from './components/Navigation';
import Home from './components/Home';
import About from './components/About';
import Partnership from './components/Partnership';
import Services from './components/Services';
import Products from './components/Products';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Interest from './components/Interest';
import ViewInterest from './components/ViewInterest';

function App() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const handlePopState = () => {
      setPath(window.location.pathname);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const navigate = (newPath) => {
    if (newPath !== path) {
      window.history.pushState({}, '', newPath);
      setPath(newPath);
    }
  };

  const isInterestPage = path === '/interest' || path === '/interest/';
  const isViewInterestPage = path === '/view-interest' || path === '/view-interest/';

  return (
    <div className="App">
      <Navigation />
      <main>
        {isInterestPage ? (
          <Interest />
        ) : isViewInterestPage ? (
          <ViewInterest />
        ) : (
          <>
            <Home />
            <About />
            <Partnership />
            <Services />
            <Products />
            <Contact />
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}

export default App;
